import { ContactSection } from "./ContactSection";
import { SiteFooter, SiteHeader } from "./SiteChrome";

export function ContactPage() {
  return (
    <>
      <SiteHeader />
      <main>
        <ContactSection eyebrowNumber="01" />
      </main>
      <SiteFooter />
    </>
  );
}
